import { Menu, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useFormStore } from "@/store/form-builder";
import type { QuestionScope } from "@/store/form-builder";
import { BUILDER_LABELS } from "../../data/builderLabels";
import { getAddableFieldTypes, FIELD_CATEGORIES } from "../../data/fieldTypes";

interface Props {
  scope: QuestionScope;
  compact?: boolean;
}

export function AddFieldMenu({ scope, compact }: Props) {
  const addQuestion = useFormStore((s) => s.addQuestion);
  const addableFieldTypes = getAddableFieldTypes(scope);

  return (
    <Menu shadow="lg" width={220} position="top-start" withArrow>
      <Menu.Target>
        {compact ? (
          <Text
            component="button"
            size="sm"
            fw={600}
            c="var(--bg-brand-default,#004ddb)"
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              padding: 0,
              display: "flex",
              alignItems: "center",
              gap: 4,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            <IconPlus size={14} /> Add field
          </Text>
        ) : (
          <Text
            component="button"
            size="sm"
            fw={600}
            c="#004ddb"
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              padding: 0,
            }}
          >
            {BUILDER_LABELS.emptyStateTrigger}
          </Text>
        )}
      </Menu.Target>
      <Menu.Dropdown mah={340} style={{ overflow: "auto" }}>
        {FIELD_CATEGORIES.filter((c) => c !== "Coming Soon").map((cat) => {
          const items = addableFieldTypes.filter((f) => f.category === cat);
          if (items.length === 0) return null;
          return (
            <div key={cat}>
              <Menu.Label tt="uppercase" fz={10} fw={700}>
                {cat}
              </Menu.Label>
              {items.map((f) => {
                const Icon = f.icon;
                return (
                  <Menu.Item
                    key={f.id}
                    leftSection={<Icon size={14} />}
                    onClick={() => addQuestion(scope, f.id)}
                  >
                    {f.label}
                  </Menu.Item>
                );
              })}
            </div>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
